<template lang="html"><div></div></template>

<script>

export default {
  name: 'SecurityComponent',
  data() {
    return {
      scCanCreate: false,
      scCanUpdate: false,
      scCanDelete: false,
    };
  },
  methods: {
    getMenuPolicy() {
      const componentName = this.$options.name;
      let menuPolicy = null;
      this.$store.state.menuPolicy.forEach((mp) => {
        if (menuPolicy == null) {
          if (mp.vue_component === componentName) {
            menuPolicy = mp;
          } else if (mp.sub_menu) {
            menuPolicy = mp.sub_menu.find((smp) => smp.vue_component === componentName);
          }
        }
      });
      return menuPolicy;
    },

    getPolicy() {
      const menuPolicy = this.getMenuPolicy();
      return menuPolicy ? menuPolicy.policy : null;
    },

    getTabs() {
      const menuPolicy = this.getMenuPolicy();
      return (menuPolicy && menuPolicy.sub_menu) ? menuPolicy.sub_menu : [];
    },

  },
  mounted() {
    const policy = this.getPolicy();
    if (policy) {
      this.scCanCreate = policy.can_create;
      this.scCanUpdate = policy.can_update;
      this.scCanDelete = policy.can_delete;
    }
  },
};
</script>
